import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { TrendingUp, TrendingDown, BarChart3 } from 'lucide-react';

function gradeColor(note) {
  if (note >= 16) return 'text-emerald-400';
  if (note >= 12) return 'text-blue-400';
  if (note >= 10) return 'text-amber-400';
  return 'text-red-400';
}

export function ResultsStatsCards({ stats }) {
  if (!stats || stats.count === 0) return null;

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 stagger-children">
        <Card className="bg-card border-border">
          <CardContent className="p-4 text-center">
            <p className="text-2xl font-black">{stats.count}</p>
            <p className="text-xs text-muted-foreground">Copies</p>
          </CardContent>
        </Card>
        <Card className="bg-card border-border">
          <CardContent className="p-4 text-center">
            <p className={`text-2xl font-black ${gradeColor(stats.moyenne)}`}>{stats.moyenne}</p>
            <p className="text-xs text-muted-foreground">Moyenne</p>
          </CardContent>
        </Card>
        <Card className="bg-card border-border">
          <CardContent className="p-4 text-center">
            <p className="text-2xl font-black text-emerald-400">{stats.max}</p>
            <p className="text-xs text-muted-foreground flex items-center justify-center gap-1"><TrendingUp className="w-3 h-3" /> Max</p>
          </CardContent>
        </Card>
        <Card className="bg-card border-border">
          <CardContent className="p-4 text-center">
            <p className="text-2xl font-black text-red-400">{stats.min}</p>
            <p className="text-xs text-muted-foreground flex items-center justify-center gap-1"><TrendingDown className="w-3 h-3" /> Min</p>
          </CardContent>
        </Card>
        <Card className="bg-card border-border">
          <CardContent className="p-4 text-center">
            <p className="text-2xl font-black">{stats.median}</p>
            <p className="text-xs text-muted-foreground">Médiane</p>
          </CardContent>
        </Card>
      </div>

      {stats.distribution && (
        <Card className="bg-card border-border">
          <CardHeader className="pb-2">
            <CardTitle className="text-base flex items-center gap-2">
              <BarChart3 className="w-4 h-4 text-primary" /> Distribution
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-4 gap-3">
              {[
                { label: 'Excellent (16+)', count: stats.distribution.excellent, color: 'bg-emerald-400' },
                { label: 'Bien (12-15)', count: stats.distribution.bien, color: 'bg-blue-400' },
                { label: 'Passable (10-11)', count: stats.distribution.passable, color: 'bg-amber-400' },
                { label: 'Insuffisant (<10)', count: stats.distribution.insuffisant, color: 'bg-red-400' },
              ].map((d) => (
                <div key={d.label} className="text-center">
                  <div className="flex items-end justify-center h-16 mb-2">
                    <div
                      className={`${d.color} rounded-t w-8 transition-all duration-500`}
                      style={{ height: `${Math.max(4, (d.count / Math.max(stats.count, 1)) * 64)}px` }}
                    />
                  </div>
                  <p className="text-lg font-bold">{d.count}</p>
                  <p className="text-xs text-muted-foreground">{d.label}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
}
